export default "__VITE_ASSET__7033a7f5__"